module.exports = __webpack_public_path__ + "img/hohlsaum_ultramarinblau_ral5002.9f612962.jpg";